import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

export const adminApi = () => {
  const token = localStorage.getItem("allstar_admin_token") || "";
  return axios.create({
    baseURL: API,
    headers: { "X-Admin-Token": token },
  });
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_5702b075-9100-4f0e-9f10-9729d5840616/artifacts/hxyq65l2_C5CE14BB-81D5-48A0-9EFB-07D10B926DA6.PNG";
